import { withBemMod } from '@bem-react/core';

import { cnPopup } from '../Popup';

import './Popup_view_regular.scss';

export interface PopupViewRegularProps {
    view: 'regular';
}

export const withPopupViewRegular = withBemMod<PopupViewRegularProps>(cnPopup(), { view: 'regular' });
